const STORE_NAMESPACES = Object.freeze({
  EXAMPLE: 'example',
  ROUTER: 'router',
  SECURITY: 'security',
})

export default STORE_NAMESPACES
